import { modules } from "@/components/dataset-modules";

export default {
    Name: 'name',
    Street: "street",
    City: "city",
    State: "state",
    'Zip Code': "zipcode",
    Phone: 'phone',
    Email: 'email',
    'Follow Up':'followup',
    'Client Type': "clientTypeValue",
    'Status': "clientContractValue",
    'Urgency': "clientStatusValue",
    'Budget/1s Ask':'budget',
    'Sale Price':"salePrice",
    'Commission %': "commission",
    'Flat Fee Commission': "flatFeeCommission",
    'Co-Broke ?': "coBrokeIsSelected",
    'Co-Broke %':"coBroke",
    'Gross Commission': "grossCommission",
    'Referral': "referral",
    'Split': "split",
    'Projected Commission': "projectedCommission",
    'Net Commission':'actualCommission',
    'Expenses':'expenses',
    'Tax Projection':"taxProjection",
    'Hours Spent': "hoursSpent",
    'Listing Date':"listingDate",
    'Contract Date':"contractDate",
    'Closing Date':"closingDate",
    'Listing ID':"listingId",
    'Lead Source':"source",
    'Neighborhood':"neighborhood",
    'Property Type': "propertyType",
    'Days On Market': "daysOnMarket",
    'Company Payment': "companyPayment",
    'Referral Payment': "referralPayment",
    'Notes':"note",
   
}